<template>
	<footer class="mt-auto text-gray-300 bg-gray-900">
		<div class="container px-4 py-12 mx-auto">
			<div class="grid grid-cols-1 gap-8 mb-8 md:grid-cols-2 lg:grid-cols-4">
				<!-- Brand Section -->
				<div class="lg:col-span-2">
					<router-link
						to="/"
						class="inline-flex items-center gap-3 mb-4 transition-colors duration-200 rounded group hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
					>
						<img :src="LogoSvg" alt="Schule Leichter Logo" class="w-10 h-10" />
						<span class="text-xl font-bold text-white">Schule-leichter.de</span>
					</router-link>
					<p class="max-w-md text-sm leading-relaxed text-gray-400">
						Hilfreiche Ressourcen und wissenschaftlich fundierte Tests für besseres Lernen und
						schulischen Erfolg. Entdecke deinen individuellen Lerntyp und optimiere deine
						Lernstrategien.
					</p>
				</div>

				<!-- Navigation Links -->
				<div>
					<h3 class="mb-4 text-sm font-semibold tracking-wider text-white uppercase">Navigation</h3>
					<ul class="space-y-2 text-sm">
						<li v-for="link in navigationLinks" :key="link.path">
							<router-link
								:to="link.path"
								class="inline-block text-gray-400 transition-colors duration-200 hover:text-white focus:outline-none focus:text-white"
							>
								{{ link.label }}
							</router-link>
						</li>
					</ul>
				</div>

				<!-- Legal Links -->
				<div>
					<h3 class="mb-4 text-sm font-semibold tracking-wider text-white uppercase">
						Rechtliches
					</h3>
					<ul class="space-y-2 text-sm">
						<li v-for="link in legalLinks" :key="link.path">
							<router-link
								:to="link.path"
								class="inline-block text-gray-400 transition-colors duration-200 hover:text-white focus:outline-none focus:text-white"
							>
								{{ link.label }}
							</router-link>
						</li>
					</ul>
				</div>
			</div>

			<!-- Divider -->
			<div class="pt-8 border-t border-gray-800">
				<!-- Copyright & Credits -->
				<div
					class="flex flex-col items-center justify-between gap-4 text-sm text-gray-400 md:flex-row"
				>
					<p>&copy; {{ currentYear }} Schule-leichter.de. Alle Rechte vorbehalten.</p>
					<p class="flex items-center gap-1">
						Entwickelt mit <span class="text-red-500" aria-label="Liebe">❤️</span> für besseres
						Lernen
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LogoSvg from '@/assets/logo_square.svg?url';

interface FooterLink {
	path: string;
	label: string;
}

const currentYear = computed(() => new Date().getFullYear());

const navigationLinks: FooterLink[] = [
	{ path: '/', label: 'Startseite' },
	{ path: '/info/lerntypen', label: 'Lerntypen Test' },
	{ path: '/info/lernschwierigkeiten', label: 'Lernschwierigkeiten' },
	{ path: '/info/hausaufgaben-tipps', label: 'Hausaufgaben-Tipps' },
];

const legalLinks: FooterLink[] = [
	{ path: '/impressum', label: 'Impressum' },
	{ path: '/datenschutz', label: 'Datenschutz' },
	{ path: '/agb', label: 'AGB' },
];
</script>

<style scoped>
/* Ensure footer stays at bottom */
footer {
	margin-top: auto;
}
</style>
